import 'react-circular-progressbar/dist/styles.css';
import { Rating } from 'react-simple-star-rating';
import { LoadingSpinner } from '../../shared-components/LoadingSpinner/LoadingSpinner';

interface IProps {
  externalReviewCount: number;
  externalReviewRating: number;
  websiteReviewCount: number;
  websiteReviewRating: number;
}
export interface MyErrorObject {
  product?: string;
  cities?: string;
  date?: string;
}
const ReviewsHeader = ({
  externalReviewCount,
  externalReviewRating,
  websiteReviewCount,
  websiteReviewRating
}: IProps) => {
  const sumOfReviewCount = websiteReviewCount + externalReviewCount;
  const sumOfReviewRating =
    externalReviewRating && externalReviewRating > 0
      ? (websiteReviewRating + externalReviewRating) / 2
      : websiteReviewRating;

  const isLoadingCount = websiteReviewCount < 1 || externalReviewCount < 1;
  const isLoadingRating = websiteReviewRating < 1 || externalReviewRating < 1;

  return (
    <div id="reviews" className="bg-[#FFFFFF] md:pb-10 mt-8 ">
      <div className=" text-center">
        <div className="text-[32px] md:text-[48px] text-primary font-bold">
          Reviews & Testimonials
        </div>
        <div className="text-[15px] md:[18px]  px-3 md:px-0 xl:text-[18px] text-[#374473] font-normal">
          Join thousands of satisfied travelers who have shared their stories
        </div>
        <div className="flex justify-center gap-10 text-left mt-2">
          <div className="hidden md:block">
            <div className="text-[16px] text-primary font-[700] mt-[9px] mr-2">
              {isLoadingCount ? (
                <LoadingSpinner className="w-6 h-6" />
              ) : (
                `${sumOfReviewCount} Reviews`
              )}
            </div>
            <div className="text-[18px] font-500 text-[#374473] mt-[4px] ">
              Total Verified Reviews
            </div>
          </div>
          <div>
            <div className="text-[16px] text-primary font-[700] mt-0 md:mt-[6px]  mr-2">
              {isLoadingRating ? (
                <LoadingSpinner className="w-6 h-6" />
              ) : (
                <div className="w-full flex items-center mb-1">
                  <p className="text-[15px] text-primary font-[700] mt-[3px] mr-2">
                    {sumOfReviewRating.toFixed(1)}
                  </p>
                  <Rating
                    initialValue={sumOfReviewRating}
                    readonly
                    iconsCount={5}
                    size={16}
                    allowHover={false}
                    disableFillHover
                    fillColor="orange"
                    emptyColor="#9B9B9B"
                    allowFraction
                    SVGstyle={{
                      display: 'inline-block'
                    }}
                  />
                  <span className="font-[300] text-black text-[9px] mt-1 md:hidden">
                    ({sumOfReviewCount})
                  </span>
                </div>
              )}
            </div>

            <div className="text-[18px] font-500 text-[#374473] hidden md:block ">
              Total Ratings
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsHeader;
